import { FC, useMemo } from 'react';

import styles from './GeoLabel.css';
import { stopPropagation } from 'shared/utils/event';
import { IGeoLabel } from '../../types';

export const GeoLabel: FC<IGeoLabel> = ({ url, label }) => {
  const Elem = useMemo(() => (url ? 'a' : 'span'), [url]);

  return (
    <Elem className={styles['link']} href={url} target="_blank" onClick={stopPropagation}>
      {label}
    </Elem>
  );
};
